export async function AgeCalculation(birthDate) {
    const date_time = Date.parse(birthDate);

    const diff_ms = Date.now() - date_time;
    const age_dt = new Date(diff_ms); 

    return Math.abs(age_dt.getUTCFullYear() - 1970);
}